/* External Imports */

import { Box, Heading } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import config from '@config';
/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const TopBannerSimple = ({ sectionContent }) => {
  return (
    <Box
      maxW="100%"
      w="100%"
      h="200px"
      bgImage={`url(${config.imgPath}/d/46272/1722363285-footer-background.jpg)`}
      pt={{ base: '75px' }}
      bgColor="#010509"
      bgRepeat="no-repeat"
      bgPos={{ base: 'center bottom', md: 'center bottom' }}
      bgSize={{ base: 'cover', md: 'cover' }}
      textAlign="center"
    >
      <Heading
        as="h1"
        fontSize={{ base: '44px', lg: '50px', '2xl': '60px' }}
        fontFamily={'var(--FedraSerifDisplay-Bold)'}
        lineHeight={{ base: '2.55rem', lg: '60px', '2xl': '2.025rem' }}
        letterSpacing={'0.16px'}
        color="#FEFAF6"
        px={{ base: '15px', lg: '0' }}
      >
        {sectionContent?.title}
      </Heading>
    </Box>
  );
};

export default TopBannerSimple;
